function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m76.845 90.067c-11.144 1.4581-35.248 1.5024-56.173-22.981-19.98-25.26-18.781-49.275-15.197-59.926 8.735-3.9707 20.822-4.218 25.832-3.3788 4.3214 7.3372 6.279 18.841 4.5552 27.112-2.3416 2.1164-8.5542 5.9887-11.429 7.2536 0.68291 5.0018 4.7914 11.115 9.4007 16.72 4.6081 5.6035 9.8117 10.816 14.588 12.454 1.794-2.579 6.7934-7.9242 9.3232-9.8129 8.4496-0.09351 19.356 4.0482 25.722 9.7071-0.1452 5.0769-1.0397 15.05-6.6224 22.853z",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.7675
});

var SvgChiama = function SvgChiama(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 86.872,
    height: 94,
    enableBackground: "new -0.021 -0.052 166 166",
    viewBox: "-.021 -.052 86.872 94",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChiama, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chiama.5fbe93c6.svg";
export { ForwardRef as ReactComponent };